import Login from 'pages/mypage/login/index';
import React from 'react';
import { RouteObject } from 'react-router-dom';

/**
 * ルート定義
 */
export class StaticPageRouteHelper {
  public static root = (): string => '/';
}

export const staticRoutes: RouteObject[] = [{ index: true, element: <Login /> }];
